export const experienceData = [
    {
        id: 1,
        company: 'Dataviv Technologies',
        jobtitle: 'Frontend Developer',
        startYear: 'December2021',
        endYear: 'June2023'
    }, {
        id: 2,
        company: 'Purple Style Labs',
        jobtitle: 'Associate Software Developer',
        startYear: 'June2023',
        endYear: 'Present'
    }
]